mutation AttachPaymentDocument($input: AttachPaymentDocumentInput!) {
  attachPaymentDocument(input: $input) {
    clientMutationId
    entityDocuments {
      id
      fileReference
    }
  }
}
